import React from 'react';
import OECheckbox from '../../../../global/oe-checkbox/oe-checkbox';
import Text from '../../../../global/text/text';
import {IReportConfigItem} from '../../../../../api/reports.dao';
import './report-field-item.scss';

interface IProps {
    field: IReportConfigItem;
    toggle: (field: IReportConfigItem) => void;
}

const ReportFieldItem = (props: IProps) => {
    const { field, toggle } = props;

    return (
        <div className='report-field-item'>
            <OECheckbox
                checked={field.enabled}
                onChange={() => toggle(field)}
                label={<Text withEllipsis message={field.label} />}
            />
        </div>
    );
};

export default ReportFieldItem;
